import moment from "moment";

export const YOUTUBE_ANALYTICS_MOCK_BINDING = {
  platform_link: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
  youtube_video_id: "dQw4w9WgXcQ",
  youtube_channel_id: "UCuAXFkgsw1L7xaCfnd5JJOw",
};

export function buildYoutubeAnalyticsMockEstimateRows() {
  const rows = [];
  for (let i = 59; i >= 0; i -= 1) {
    const d = moment().subtract(i, "days").format("YYYY-MM-DD");
    const wave = 70 + Math.sin(i / 4.2) * 35 + (59 - i) * 0.35;
    rows.push({
      id: 9000 + (59 - i),
      estimate_date: d,
      revenue_usd_estimate: Number(wave.toFixed(3)),
      views_estimate: Math.round(3200 + i * 95 + (i % 7) * 180),
      estimated_minutes_watched: Number(
        (620 + i * 12 + (i % 5) * 40).toFixed(1)
      ),
    });
  }
  return rows;
}

export const YOUTUBE_ANALYTICS_MOCK_ALL_ROWS =
  buildYoutubeAnalyticsMockEstimateRows();

/** Inclusive calendar month as [startOfDay, endOfDay] for queries and filters. */
export function dateBoundsForCalendarMonth(monthMoment) {
  if (
    !monthMoment ||
    typeof monthMoment.isValid !== "function" ||
    !monthMoment.isValid()
  ) {
    return null;
  }
  const start = monthMoment.clone().startOf("month").startOf("day");
  const end = monthMoment.clone().endOf("month").endOf("day");
  return [start, end];
}

export function filterYoutubeAnalyticsEstimatesByRange(rows, range) {
  if (!range || !range[0] || !range[1]) return rows;
  const from = range[0].format("YYYY-MM-DD");
  const to = range[1].format("YYYY-MM-DD");
  return rows.filter((r) => r.estimate_date >= from && r.estimate_date <= to);
}
